import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ChildEventStore from "./Components/ChildEventStore";
import { MyContext } from "./State/ProviderData";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { isLoggedIn } from "./Auth/auth";
// Style dédié aux lignes du calendrier (fond gris, formats en pastille orange)
import "./EpreuvesList2.scss";

export const EpreuvesList2 = (props) => {
  const { epreuves } = props;
  const [myData, setMyData] = useContext(MyContext);
  const [basket, setBasket] = useState(myData);
  const [keyRefresh, setKeyRefresh] = useState(new Date());

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("basket"));
    if (storedData && storedData != null) {
      setBasket(storedData);
    }
  }, []);

  useEffect(() => {
    if (basket) {
      localStorage.setItem(
        "basket",
        JSON.stringify(basket.filter((e) => e != null)),
        null
      );
      setKeyRefresh(new Date());
      setMyData(basket);
    }
  }, [basket, setMyData]);

  const addEvent = (epreuve) => {
    setBasket((prevData) => [
      ...prevData,
      { id: epreuve.id, name: epreuve.name_event },
    ]);
  };

  const removeEvent = (epreuve) => {
    setBasket((prevData) =>
      prevData.filter((e) => e != null).filter((item) => item.id !== epreuve.id)
    );
  };

  return epreuves ? (
    <div className="w-100 epreuves-list">
      {epreuves.map((epreuve, index) => (
        <div className="row" key={index}>
          <div className="col-12">
            <div
              className="row epreuve-row mb-2 hoverCardColor align-items-center position-relative"
              key={epreuve.id + epreuve.name_event}
              style={{ height: "auto" }}
            >
              {/* Link en display:contents : sert de zone cliquable pour la
                  carte sans casser la mise en page en grille (row/col) ni
                  imbriquer les icônes d'action dans un <a>, ce qui aurait
                  déclenché une navigation au clic sur l'icône elle-même. */}
              <Link
                to={`${process.env.PUBLIC_URL}/epreuve/${epreuve.id}?${
                  epreuve.name_event
                }&filter${epreuve.date.slice(-13, -9)}`}
                className="text-dark text-decoration-none itemTri"
                style={{ display: "contents" }}
                key={keyRefresh}
              >
                {/* Date et ville dans deux colonnes distinctes */}
                <div className="col-lg-2 col-12 media-content">
                  <span className="date-pill">
                    {epreuve.date.slice(0, 10)}
                  </span>
                </div>
                <div className="col-lg-2 col-12 media-content">
                  <span className="city-pill">
                    {epreuve.city} ({epreuve.department})
                  </span>
                </div>
                <div className="col-lg-4 col-12 media-content font-weight-bold pl-md-4">
                  {epreuve.name_event}
                </div>
                {/* Formats de course : fond orange, sans cadre */}
                <div className="col-lg-4 col-12 media-content format-pills">
                  {epreuve.races.map((item, idx) => (
                    <span
                      key={item.type_triathlon + item.name_race + idx}
                    >
                      {item.type_triathlon}
                    </span>
                  ))}
                </div>
              </Link>

              {/* Icônes d'action intégrées dans la carte (coin supérieur
                  droit), en dehors du Link ci-dessus pour éviter tout
                  conflit de navigation au clic. */}
              {props.remove === true ? (
                <div className="card-actions">
                  <ChildEventStore
                    epreuve={epreuve}
                    addEvent={addEvent}
                    removeEvent={removeEvent}
                  />
                  <Link
                    to={{
                      pathname: `${process.env.PUBLIC_URL}/epreuves/update`,
                      state: { eventRef: epreuve },
                    }}
                  >
                    {isLoggedIn() ? (
                      <BorderColorIcon className="text-warning" />
                    ) : null}
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      ))}
    </div>
  ) : null;
};

export default EpreuvesList2;
